/** Launch/dismiss overlays
 *  ------------------------------------------------------------------------------------------------
**/

/** Open overlays
 *  ------------------------------------------------------------------------------------------------
 *  open buttons:
 *  data-overlay = the ID of the overlay
 *  data-pass-class = this class is added to the overlay if opened by this button (removed on close)
<button
	class="js--overlay-trigger"
	data-overlay="js--hm-add-multiple-events-form"
	data-pass-class="hm-add-multiple-events--$currentKey"
>
	Add Multiple Events
</button>
 * The overlay itself should look something like:
 * data-base-class is what the class will be set to on close (unchanged if not set)
<div
	id="js--hm-add-multiple-events-form"
	class="js--overlay generic-overlay"
	data-base-class="js--overlay generic-overlay"
>
	<div class="generic-overlay__container">
		<button class="generic-overlay__back-close js--overlay-close">
		<span class="visuallyhidden">close</span>
		</button>
		<div class="generic-overlay__wrap">
			...
		</div>
	</div>
</div>
**/
const openOverlay = (e) => {
	// we open the overlay regardless but only prevent the default for left clicks.
	// means we can still open a new tab or right click to use <a> as fallbacks...
	// ref: https://www.jacklmoore.com/notes/click-events/
	if (!(e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey)) {
		e.preventDefault();
	}

	const addClass = e.currentTarget.getAttribute('data-pass-class');

	const target = document.getElementById(e.currentTarget.getAttribute('data-target'));
	if (target) {
		const scroll = window.pageYOffset
			|| document.documentElement.scrollTop
			|| document.body.scrollTop;
		document.body.setAttribute('data-scroll-pos', scroll);
		document.body.classList.add('js--has-overlay');

		// REF - https://weser.io/blog/scroll-blocking-overlays
		// nice hack for blocking body scroll on older mobile devices
		const scrollElement = document.scrollingElement;
		// clip allows nested sticky elements to still work so is nicer if supported
		// it's also a (half-arsed) detect for modern mobile browsers,
		// which don't need the position fixed hack
		if (
			window.CSS
			&& window.CSS.supports('overflow', 'clip')
		) {
			scrollElement.style.overflow = 'clip';
		} else {
			scrollElement.style.overflow = 'hidden';
			scrollElement.style.position = 'fixed';
			scrollElement.style.top = `${-scroll}px`;
			scrollElement.style.width = '100%';
		}
		scrollElement.style.scrollBehavior = 'auto';

		target.classList.add('js--overlay--active');

		if (addClass) {
			target.classList.add(addClass);
		}

		// wait a tick for the transition class so that it animates...
		window.setTimeout(() => target.classList.add('js--overlay--active-trans-in'), 10);
	}
};

/** Close overlays
 *  ------------------------------------------------------------------------------------------------
 *  close buttons:
<button
	class="js--overlay-close"
>
	Close!
</button>
**/
export const closeOverlays = () => {
	document.body.classList.remove('js--has-overlay');
	const scrollElement = document.scrollingElement;
	scrollElement.style.removeProperty('position');
	scrollElement.style.removeProperty('overflow');
	scrollElement.style.removeProperty('top');
	scrollElement.style.removeProperty('width');
	window.scrollTo(0, document.body.getAttribute('data-scroll-pos') || 0);
	scrollElement.style.removeProperty('scroll-behavior');
	const activeOverlays = document.querySelectorAll('.js--overlay--active');
	(activeOverlays || []).forEach(
		(active) => {
			const baseClass = active.getAttribute('data-base-class');
			if (baseClass) {
				// eslint-disable-next-line no-param-reassign
				active.className = baseClass;
			} else {
				active.classList.remove('js--overlay--active-trans-in');
				active.classList.remove('js--overlay--active');
			}
		},
	);
};

/** Initialise listeners
 *  ------------------------------------------------------------------------------------------------
**/
export const init = () => {
	const overlayTriggers = document.querySelectorAll('.js--overlay-trigger');
	(overlayTriggers || []).forEach(
		(trigger) => {
			trigger.addEventListener('click', openOverlay, false);
		},
	);
	const overlayClosers = document.querySelectorAll('.js--overlay-close');
	(overlayClosers || []).forEach(
		(closer) => {
			closer.addEventListener('click', closeOverlays, false);
		},
	);

	// close with esc key
	document.body.addEventListener('keyup', (e) => {
		if (e.key.toLowerCase() === 'escape') {
			closeOverlays();
		}
	});
};

export default init;
